import type {
	InfractionMetricFilter,
	InfractionStatus,
} from "../types/infraction.types";
import { INFRACTION_METRIC_FILTER } from "./infraction-metrics.constant";
import { INFRACTION_STATUS } from "./infraction-status.constant";

/** Valores de `InfractionOperationalFilter` conforme backend. */
export const INFRACTION_OPERATIONAL_FILTER = {
	CRITICAL: 1,
	AWAITING_DRIVER_INDICATION: 2,
	DRIVER_INDICATION_EXPIRED: 3,
	NIC_RISK: 4,
	PENDING_TOTAL: 5,
	NOTIFICATION_RECEIVED: 6,
	DRIVER_ASSIGNED: 7,
	PENDING_PAYMENT: 8,
	PAYMENT_EXPIRED: 9,
	PAID: 10,
	CANCELLED: 11,
} as const;

export const INFRACTION_METRIC_TO_OPERATIONAL_FILTER: Record<
	Exclude<InfractionMetricFilter, "all">,
	number
> = {
	[INFRACTION_METRIC_FILTER.CRITICAL]: INFRACTION_OPERATIONAL_FILTER.CRITICAL,
	[INFRACTION_METRIC_FILTER.AWAITING_INDICATION]:
		INFRACTION_OPERATIONAL_FILTER.AWAITING_DRIVER_INDICATION,
	[INFRACTION_METRIC_FILTER.NIC_RISK]: INFRACTION_OPERATIONAL_FILTER.NIC_RISK,
	[INFRACTION_METRIC_FILTER.PENDING_TOTAL]:
		INFRACTION_OPERATIONAL_FILTER.PENDING_TOTAL,
};

/** Mapeia status de domínio para filtro operacional da API (quando existir equivalente). */
export const INFRACTION_STATUS_TO_OPERATIONAL_FILTER: Partial<
	Record<InfractionStatus, number>
> = {
	[INFRACTION_STATUS.NOTIFICATION_RECEIVED]:
		INFRACTION_OPERATIONAL_FILTER.NOTIFICATION_RECEIVED,
	[INFRACTION_STATUS.AWAITING_DRIVER_INDICATION]:
		INFRACTION_OPERATIONAL_FILTER.AWAITING_DRIVER_INDICATION,
	[INFRACTION_STATUS.DRIVER_INDICATED]:
		INFRACTION_OPERATIONAL_FILTER.DRIVER_ASSIGNED,
	[INFRACTION_STATUS.PAID]: INFRACTION_OPERATIONAL_FILTER.PAID,
	[INFRACTION_STATUS.EXPIRED]:
		INFRACTION_OPERATIONAL_FILTER.DRIVER_INDICATION_EXPIRED,
	[INFRACTION_STATUS.PAYMENT_EXPIRED]:
		INFRACTION_OPERATIONAL_FILTER.PAYMENT_EXPIRED,
	[INFRACTION_STATUS.CANCELLED]: INFRACTION_OPERATIONAL_FILTER.CANCELLED,
	[INFRACTION_STATUS.PAYMENT_PENDING]:
		INFRACTION_OPERATIONAL_FILTER.PENDING_PAYMENT,
};
